const directoryPickerAbortMessages = [
  'showDirectoryPicker',
  'The user aborted a request',
];

export const isExpectedDirectoryPickerAbort = (
  error: Error | undefined,
): boolean => {
  const message = error?.message ?? '';

  return (
    error?.name === 'AbortError' &&
    directoryPickerAbortMessages.some(fragment => message.includes(fragment))
  );
};

const installDirectoryPickerAbortGuard = () => {
  if (typeof window === 'undefined') {
    return;
  }

  type DirectoryPicker = (...args: unknown[]) => Promise<unknown>;
  const browserWindow = window as Window & {
    __drivelineDirectoryPickerAbortGuard?: true;
    showDirectoryPicker?: DirectoryPicker;
  };

  if (
    browserWindow.__drivelineDirectoryPickerAbortGuard ||
    !browserWindow.showDirectoryPicker
  ) {
    return;
  }

  const originalShowDirectoryPicker =
    browserWindow.showDirectoryPicker.bind(window);

  browserWindow.showDirectoryPicker = (...args: unknown[]) =>
    originalShowDirectoryPicker(...args).catch(error => {
      if (isExpectedDirectoryPickerAbort(error as Error | undefined)) {
        return new Promise<unknown>(() => undefined);
      }

      throw error;
    });

  browserWindow.__drivelineDirectoryPickerAbortGuard = true;
};

installDirectoryPickerAbortGuard();
